<template>
  <div class="is-flex is-align-items-center is-flex-wrap-wrap">
    <p class="ml-3">{{ text }}</p>
    <BaseDropdown v-if="isEditable" wrapperClasses="is-right" :isOpen="isEditing" @update:isOpen="isEditing = $event">
      <template v-slot:dropdown-trigger="{ handleToggle }">
        <button @click="handleToggle" class="button">
          <span class="icon is-small">
            <img src="/edit.svg" alt="Edit" />
          </span>
        </button>
      </template>
      <div class="m-2">
        <textarea
          v-model="currentComment"
          class="textarea is-small"
          rows="10"
          style="width: 300px;"
        ></textarea>
      </div>
      <hr class="dropdown-divider" />
      <div class="buttons mx-2">
        <button class="button is-small is-success" @click="saveComment">שמור</button>
        <button class="button is-small mx-2" @click="cancelEdit">ביטול</button>
      </div>
    </BaseDropdown>
  </div>
</template>

<script>
import BaseDropdown from '@/components/shared/atoms/BaseDropdown.vue'

export default {
  name: 'ApplicantComment',
  components: {
    BaseDropdown
  },
  props: {
    applicantId: {
      type: Number,
      required: true
    },
    applicantJobTitle: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    drySave: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEditing: false,
      currentComment: this.applicantJobTitle.applicant_comment,
      text: this.applicantJobTitle.applicant_comment || 'Click on icon to add comment'
    }
  },
  methods: {
    cancelEdit () {
      this.isEditing = false
    },
    async saveComment () {
      this.cancelEdit()
      if (this.currentComment === this.applicantJobTitle.applicant_comment) {
        return
      }
      this.text = this.currentComment
      this.$emit('updated', { id: this.applicantJobTitle.id, value: this.currentComment })
      if (!this.drySave) {
        await this.$network_utils.updateApplicantJobTitle({
          job_title_id: this.applicantJobTitle.id,
          applicant_id: this.applicantId,
          applicant_comment: this.currentComment
        })
      }
    }
  }
}
</script>
